<template>
  <DsForm
    :validation-errors="errors"
    class="w-full"
    @submit.prevent
  >
    <DsAlert v-if="errorMsg" type="error" class="mb-5">{{ errorMsg }}</DsAlert>

    <DsFormGroup
      validation-name="email"
      label="E-Mail Adresse"
      label-for="email"
      class="mb-3"
    >
      <DsInput
        id="email"
        v-model="form.email"
        immediate
        type="email"
        :disabled="loading"
        autocomplete="email"
        size="lg"
        required
      />
    </DsFormGroup>

    <DsFormGroup
      validation-name="password"
      label="Passwort"
      label-for="Passwort"
    >
      <DsInput
        id="Passwort"
        v-model="form.password"
        name="password"
        :disabled="loading"
        autocomplete="current-password"
        size="lg"
        required
        type="password"
      />
    </DsFormGroup>

    <ElButton
      class="mt-1 w-full"
      text
      size="large"
      @click="handleSwitchToEmail"
    >
      {{ params.redirect ? 'Noch kein Passwort gesetzt?' : 'Passwort vergessen?' }}
    </ElButton>

    <div class="mt-6 lg:mt-10 space-y-2">
      <DsButton
        type="submit"
        variant="primary"
        size="lg"
        class="w-full"
        :handler="submit"
      >
        Anmelden
      </DsButton>
      <div class="max-lg:hidden text-muted text-center">Oder</div>
      <DsButton
        :disabled="loading"
        variant="outline"
        size="lg"
        class="w-full"
        @click="handleSwitchToEmail"
      >
        Ohne Passwort anmelden
      </DsButton>
    </div>
  </DsForm>
</template>

<script setup lang="ts">
import {
  DsAlert,
  DsButton,
  DsForm,
  DsFormGroup,
  DsInput,
} from '@demvsystems/design-components';
import { ElButton } from 'element-plus';
import { onMounted } from 'vue';

import { TrackEventCategory } from '@/application/utils/tracking/events';

import { useForm } from "@/api/lib/integration";
import { passwordLogin } from "@/api/auth/authApi";
import { getDeviceName, isNativePlatform } from "@/application/utils/envInfo";
import { useTagManager } from '@demv_systems/feu-tag-manager';
import { useUrlSearchParams } from '@vueuse/core'

const emit = defineEmits(['switch-to-mail', 'two-factor-challenge']);

const params = useUrlSearchParams('history')

const { form , errors, submit, errorMsg, loading } = useForm(
  passwordLogin,
  { email: '', password: '' },
  async (requestAccessToken) => {
    emit('two-factor-challenge', requestAccessToken);
  }
);

defineExpose({ form, errors });

function handleSwitchToEmail() {
  emit('switch-to-mail');
  useTagManager().push({ event: TrackEventCategory.LOGIN_VIA_MAIL, action: 'zur E-Mail Anmeldung' })
}

onMounted(async () => {
  if (isNativePlatform) {
    // @ts-ignore
    form.value.deviceName = await getDeviceName();
  }
})
</script>
